import { VariantProps, cva } from "class-variance-authority";
import { ReactNode } from "react";
import "./styles.scss";

type Element =
  | "dt"
  | "dd"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "span"
  | "strong"
  | "legend";

export const textStyles = cva("inline-block text-[rgb(38,38,37)]", {
  variants: {
    alignment: {
      left: "text-left",
      center: "text-center",
      right: "text-right",
    },
    tone: {
      base: "text-[rgb(38,38,37)]",
      destructive: "text-red-500",
      subdued: "text-gray-500",
      caution: "text-yellow-500",
      ghost: "!text-white",
    },
    variant: {
      headingXxs: "text-sm font-bold",
      headingXs: "text-2xl font-bold",
      headingSm: "text-3xl font-bold",
      headingMd: "text-4xl font-bold",
      headingLg: "text-5xl font-bold",
      headingXl: "text-6xl font-bold",
      bodyXs: "text-xs",
      bodySm: "text-sm",
      bodyMd: "text-md",
      bodyLg: "text-lg",
      bodyXl: "text-xl",
      body2Xl: "text-2xl",
      explanation: "text-xs text-gray-500",
    },
    fontWeight: {
      normal: "font-normal",
      bold: "font-bold",
      semiBold: "!font-semibold",
    },
    decoration: {
      dotted: "text-dotted",
    },
    transform: {
      uppercase: "uppercase",
    },
    fullWidth: {
      true: "w-full flex",
    },
    hover: {
      true: "hover:underline",
    },
  },
});

export type TextStyleProps = VariantProps<typeof textStyles>;

export type ButtonProps = TextStyleProps & {
  children: ReactNode;
  as?: Element;
};

export const Text = ({ as, children, ...props }: ButtonProps) => {
  const Element = as ?? "span";
  return (
    <Element
      {...props}
      className={textStyles({
        ...props,
      })}
    >
      {children}
    </Element>
  );
};
